<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-26 10:31:29
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 18:28:31
 -->
<template>
  <div class="eventNotice">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">事件通知</span>
    </div>
    <div class="content">
      <div class="itemContainer" v-if="eventNoticeList.length">
        <div class="item" v-for="(item, index) in eventNoticeList" :key="index">
          <el-tooltip class="describe" effect="light" :content="item.content" placement="top">
            <span class="describe">{{item.content}}</span>
          </el-tooltip>
          <span class="time">{{item.eventTime}}</span>
        </div>
        <div class="loadMore" @click="loadMore" v-if="pageNo < pages">加载更多</div>
      </div>
      <div class="noData" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'eventNotice',
  components: {
  },
  data () {
    return {
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      eventCumulativeData: {},
      eventNoticeList: [],
    }
  },
  methods: {
    /**
     * @description                   获取累计监测碰撞事件数据
     * @return {undefied}             无返回值
     */
    getEventCumulativeData () {
      this.$http.get('/rest/screen/hlpz/right-top/summary')
        .then(res => {
          if (res.code === 0) {
            this.eventCumulativeData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取事件通知数据
     * @return {undefied}             无返回值
     */
    getEventNoticeData () {
      this.$http.get('/rest/screen/hlpz/event/page', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then(res => {
          if (res.code === 0) {
            let list = res.data.list
            list.map(item => {
              item.eventTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.eventTime))
            })
            this.eventNoticeList = this.eventNoticeList.concat(list)
            this.pageNo = parseFloat(res.data.pageNo)
            this.total = parseFloat(res.data.total)
            this.pages = Math.ceil(parseFloat(res.data.total) / this.pageSize)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   加载更多
     * @return {undefied}             无返回值
     */
    loadMore () {
      this.pageNo = this.pageNo + 1
      this.getEventNoticeData()
    },
  },
  created () {
    this.getEventCumulativeData()
    this.getEventNoticeData()
  },
}
</script>

<style lang="less" scoped>
  .eventNotice {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .content {
      width: 100%;
      height: calc(100% - 90px);
      overflow-y: scroll;
      .itemContainer {
        width: 100%;
        height: 100%;
        .item {
          font-size: 18px;
          line-height: 36px;
          >span {
            display: inline-block;
            vertical-align: middle;
          }
          .describe {
            width: 60%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            color: #d6d6d7;
          }
          .time {
            color: #2a969e;
          }
        }
        .loadMore {
          font-size: 16px;
          cursor: pointer;
          text-align: center;
          color: #51afee;
        }
      }
      .noData {
        text-align: center;
        color: rgb(209, 197, 197);
        font-size: 16px;
        line-height: 30px;
      }
    }
  }
</style>
